import React from 'react';
import { Box as MuiBox, styled, BoxProps as IMuiBoxProps } from '@mui/material';


type IBottomNaviBar = {
    children?: React.ReactNode,
    drawerwidth: number,
    openSideMenu: boolean,
}


type IBox = {
    drawerwidth: number,
    openSideMenu: boolean,
} & IMuiBoxProps


const Box = styled(MuiBox, { shouldForwardProp: (prop) => prop !== 'openSideMenu' })<IBox>(({ drawerwidth, theme, openSideMenu }) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '10px',
    paddingLeft: '97px',
    borderTop: '1px solid #D7D7D7',
    backgroundColor: theme.palette.background.navbar,
    // анимация сдвига
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    // расчет сдвига при открытии бокового меню
    ...(openSideMenu && {
        marginLeft: drawerwidth - 73,
        width: `calc(100% - ${drawerwidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


export function BottomNaviBar({ children, openSideMenu, drawerwidth }: IBottomNaviBar) {

    return (
        <Box component='div'
            openSideMenu={openSideMenu}
            drawerwidth={drawerwidth}>
            {children}
        </Box>
    );
}
